module.exports = __webpack_public_path__ + "static/media/cardwarrior.28b604ab.jpg";